export default "__VITE_ASSET__CJLPYNve__"